


















































import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";
// @ts-ignore
import PasswordStrengthMeter from "vue-password-strength-meter";
import User from "@/models/user";
import IChangePassword from "@/interfaces/change-password";
import { mapState } from "vuex";

@Component({
  components: {
    PasswordStrengthMeter,
  },
  computed: {
    ...mapState("authentication", ["user"]),
  },
})
export default class Password extends Vue {
  // mapState
  user!: User;

  loading = false;
  errorMessage = "";
  passwordScore = 0;

  @Ref("currentPassword")
  currentPassword!: any;

  mounted() {
    this.currentPassword.focus();
  }

  checkPassword(rule: any, value: any, callback: any) {
    if (!value) {
      return callback(new Error("A password is required"));
    } else {
      if (this.passwordScore < 3) {
        return callback(new Error("A stronger password is required."));
      }

      return callback();
    }
  }

  passwordForm: any = {
    password: "",
    currentPassword: "",
  };

  rules: any = {
    currentPassword: [
      {
        required: true,
        message: "Current password is required",
        trigger: ["blur"],
      },
    ],
    password: [
      {
        required: true,
        validator: this.checkPassword,
        trigger: ["blur"],
      },
    ],
  };

  @Ref("passwordFormRef")
  passwordFormRef!: any;

  //
  // Used for validation
  setPasswordScore(score: number) {
    this.passwordScore = score;
  }

  submitPassword() {
    this.passwordFormRef.validate((valid: boolean) => {
      if (valid) {
        const model: IChangePassword = {
          currentPassword: this.passwordForm.currentPassword,
          newPassword: this.passwordForm.password,
          userId: this.user.id,
        };

        this.loading = true;

        this.$store.dispatch("authentication/changePassword", model).then(
          () => {
            this.loading = false;
            this.passwordFormRef.resetFields();
            this.$message({
              message: "Your password has been changed.",
              type: "success",
            });
          },
          () => {
            this.loading = false;
            this.$message({
              message:
                "Something went wrong while changing your password. Please try again.",
              type: "error",
            });
          }
        );
      }
    });
  }
}
